import { useTranslate } from "@tolgee/react";
import { useMemo } from "react";

export type QuoteBindingTypeFilter = "BINDING" | "NON_BINDING";

const ALL_BINDING_TYPES: QuoteBindingTypeFilter[] = ["BINDING", "NON_BINDING"];

export const BINDING_TYPES_MAPPING: Record<QuoteBindingTypeFilter, boolean> = {
  BINDING: true,
  NON_BINDING: false,
};

export function useQuoteBindingTypes() {
  const { t } = useTranslate(["QuoteFilter"]);

  const bindingTypeLabels: Record<QuoteBindingTypeFilter, string> = useMemo(
    () => ({
      BINDING: t("Binding"),
      NON_BINDING: t("Non-binding"),
    }),
    [t]
  );

  const bindingTypeOptions = useMemo(
    () =>
      ALL_BINDING_TYPES.map(type => ({
        value: type,
        label: bindingTypeLabels[type],
      })),
    [bindingTypeLabels]
  );

  return { bindingTypeLabels, bindingTypeOptions };
}
